// extracted by mini-css-extract-plugin
module.exports = {"actionBar":"CollectRouteQRScan_actionBar__3H_pC"};